import { createContext } from "react";

/**
 * Selected-app + session context value definition.
 *
 * Source: BRIEF_ia-redesign-frontend-implementation § 5.3.
 *
 * The Context object is exported separately from the Provider component +
 * the consumer hook so each module satisfies React Fast Refresh's
 * "components-only" export rule.
 */

/**
 * The "All locales" sentinel for the global locale selector — show everything
 * for every locale, unfiltered. `null` (not a magic string) so it can never
 * collide with a real BCP-47 code.
 *
 * ASOLOOP-UX item 1 (operator decision 2026-07-26): locale selection is a
 * HEADER control that applies to every surface (Data Signals, Experiment Hub,
 * Experiments, Content). The per-page locale switchers are retired — the
 * header is the only control.
 */
export const ALL_LOCALES = null;

export interface SelectedAppContextValue {
  workspaceId: string | null;
  userId: string | null;
  userDisplayName: string | null;
  selectedAppId: string | null;
  setSelectedAppId: (next: string | null) => void;
  /** `null` = "All locales" (see ALL_LOCALES); otherwise a BCP-47 code. */
  selectedLocale: string | null;
  setSelectedLocale: (next: string | null) => void;
}

export const SelectedAppContext = createContext<SelectedAppContextValue | null>(
  null,
);
